import { registerPlugin } from '@capacitor/core';
import type { ColorScheme } from '@/stores/appearance';

interface NativeAppearancePlugin {
  setStyle(options: { style: ColorScheme }): Promise<void>;
}

// The app's own plugin, iOS only, see ios/App/App/AppearancePlugin.swift
export const NativeAppearance = registerPlugin<NativeAppearancePlugin>('Appearance');
